<template>
	<section class="content">
		<div class="form-control bos-alert-primary d-flex align-items-center h-100 mb-3">
			<div class="row">
				<div class="col-auto d-flex align-items-center">
					<i class="fi fi-rr-info d-flex align-items-center h5 mb-0"></i>
				</div>
				<div class="col d-flex align-items-center lh-1">
					<div class="text-md">
						Ini adalah halaman terakhir sebelum ajukan tiket batch. Periksa kembali dan pastikan data yang kamu isi sudah sesuai dan benar
					</div>
				</div>
			</div>
		</div>
		<div class="card card-primary">
			<div class="card-body">
				<div class="form-control bos-alert-danger d-flex align-items-center h-100 mb-3" v-if="errorNote">
					<div class="row">
						<div class="col-auto d-flex align-items-center">
							<i class="fi fi-rr-info d-flex align-items-center h5 mb-0"></i>
						</div>
						<div class="col d-flex align-items-center lh-1">
							<div class="text-md">
								Ada error karena AWB/Resi kamu bermasalah atau Tindakan yang di-input salah, silahkan hapus/edit untuk melanjutkan proses.
							</div>
						</div>
					</div>
				</div>
				<table class="table table-hover w-100" ref="claimBatch">
					<thead>
						<tr>
							<th>
								<input type="checkbox" id="checkall" ref="checkall" name="checkall" value="1" @click="selectAll" />
							</th>
							<th>AWB/No. Resi</th>
							<th>Judul</th>
							<th>Kategori</th>
							<th>Tindakan</th>
							<th>Alasan Penolakan</th>
							<th>Keterangan</th>
							<th>Aksi</th>
						</tr>
					</thead>
					<tbody @click="handleClick"></tbody>
				</table>
			</div>
			<div class="card-footer d-flex justify-content-end mb-2">
				<button type="submit" id="submit" class="btn btn-primary" :disabled="errorNote || updating" @click="submitForm">
					<span v-if="updating" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
					Update Claim
				</button>
			</div>
		</div>
		<!-- Modal -->
		<div class="modal fade" id="updateTicketBatch" ref="modalUpdate" tabindex="-1" role="dialog" aria-labelledby="updateTicketBatchLabel" aria-hidden="true">
			<div class="modal-dialog modal-sm" role="document">
				<form @submit.prevent="updateData" class="modal-content">
					<div class="modal-header bg-light">
						<h5 class="modal-title font-weight-bold" id="updateTicketBatchLabel">Ubah Claim Batch</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body bg-white">
						<div class="form-group">
							<label class="font-weight-normal">AWB/Resi</label>
							<input type="text" name="refcode" v-model="form.refcode" placeholder="Masukkan AWB / No. Resi" class="form-control" :class="{ 'is-invalid': errors.refcode }" required />
						</div>
						<div class="form-group">
							<label class="font-weight-normal">Tindakan</label>
							<div class="row">
								<div class="col" v-for="(act, index) in actions" :key="index">
									<button type="button" class="btn" :class="(form.response == act.id ? ['bos-alert-' + act.color, 'text-' + act.color] : 'border-secondary text-secondary')" @click="form.response = act.id;form.action = act.label;category = ''" :disabled="updating" :style="{ width: '100%' }">
										{{ act.label }}
									</button>
								</div>
							</div>
						</div>
						<div class="form-group" v-if="form.response == 3">
							<label class="font-weight-normal">Alasan Penolakan</label>
							<select name="category" v-model="category" @change="changeCategory" class="form-control" :class="{ 'is-invalid': errors.category }" :required="form.response == 3">
								<option value="" selected disabled>Pilih kategori</option>
								<option v-for="(cat, index) in categories" :key="index" :value="cat">
									{{ cat }}
								</option>
							</select>
						</div>
						<div class="form-group" v-if="category == 'Lainnya'">
							<label class="font-weight-normal">Ceritakan Alasanmu</label>
							<textarea name="message" v-model="form.message" placeholder="Tuliskan alasan pembatalan" minlength="25" class="form-control h-100" style="resize: none;" :class="{ 'is-invalid': errors.message }" :required="category == 'Lainnya'">
							</textarea>
							<small class="text-danger" v-if="errors.message">Minimal 25 karakter</small>
						</div>
					</div>
					<div class="modal-footer">
						<button type="reset" class="btn btn-outline-primary" data-dismiss="modal">Kembali</button>
						<button type="submit" class="btn btn-primary" :disabled="updating">Simpan Data <span v-if="updating" class="spinner-border spinner-border-sm"></span></button>
					</div>
				</form>
			</div>
		</div>
	</section>
	<!-- /.content -->
</template>
<script>
import { createTable, authFetch } from '@/libs/hxcore';
import Swal from 'sweetalert2';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import $ from 'jquery';

export default {
	name: 'ClaimBatch',
	data() {
		return {
			errorNote: false,
			actions: [
				{ id: 2, code: 'approve', label: 'Setujui', color: 'success' },
				{ id: 3, code: 'reject', label: 'Tolak', color: 'danger' },
				{ id: 1, code: 'pending', label: 'Pending', color: 'warning' },
			],
			category: '',
			categories: [
				'Seller tidak dapat dihubungi (RTK)',
				'Belum 14 hari stuck (Breach)',
				'Return diterima',
				'Void',
				'Paket terkirim',
				'Tidak ada video unboxing (rusak)',
				'Lainnya',
			],
			customCategory: false,
			form: {
				refcode: null,
				action: null,
				response: null,
				message: null,
			},
			errors: {
				refcode: false,
				action: false,
				response: false,
				message: false,
			},
			updating: false
		}
	},
	methods: {
		changeCategory() {
			if (this.category == 'Lainnya') {
				this.form.message = '';
				this.customCategory = true;
			} else {
				this.form.message = this.category;
				this.customCategory = false;
			}
		},
		selectAll: function (e) {
			var val = e.target.checked;
			var checkboxes = document.querySelectorAll('.select-request');

			for (var i = 0; i < checkboxes.length; i++) {
				checkboxes[i].checked = val;
			}

			if (val && checkboxes.length > 0) {
				this.selectedCount = checkboxes.length;
			} else {
				this.selectedCount = 0;
			}

			if (this.selectedCount > 0) {
				$(this.$refs.btnSelected).show();
			} else {
				$(this.$refs.btnSelected).hide();
			}
		},
		handleClick(e) {
			const evt = this.$refs;
			if (e.target.closest("i")) {
				if (e.target.dataset.action == "edit") {
					var nRow = $(e.target).closest("tr").get(0);
					var iRow = this.table.fnGetPosition(nRow);
					var aData = this.table.fnGetData(iRow);

					this.form = aData;
					this.form.nRow = nRow;

					if (this.form.response == 3) {
						if (!this.categories.includes(this.form.message)) {
							this.category = 'Lainnya';
							this.form.message = '';
						} else {
							this.category = this.form.message;
						}
					} else {
						this.category = null;
					}

					$(evt.modalUpdate).modal("show");
				} else if (e.target.dataset.action == "remove") {
					var nRow = $(e.target).closest("tr").get(0);
					this.table.fnDeleteRow(nRow);
					this.errorNote = this.table.fnGetData().filter((el) => el.status == 0).length > 0;
				}
			}
		},
		getImage(file) {
			return require(`../assets/img/${file}.svg`);
		},
		/*
		selectCategory(v) {
			let cat = this.categories.filter(function (arr, i) {
				return arr.code == v;
			});

			if (cat[0].code != 6) {
				this.form.title = cat[0].label;
			} else {
				this.form.title = "";
			}
		},
		*/
		updateData() {
			if (this.form.response == 3) {
				if (this.customCategory && this.form.message.length < 25) {
					Swal.fire('Minimal 25 karakter untuk alasan penolakan.');
					return;
				} else if (!this.form.message) {
					Swal.fire('Pilih atau tuliskan alasan penolakan.');
					return;
				}
			}

			this.updating = true;
			const formData = new URLSearchParams();

			formData.append('awb[]', this.form.refcode);
			formData.append('action[]', this.form.action);
			formData.append('message[]', this.form.message);

			authFetch('/ticket/claim/detail', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				body: formData
			})
			.then((res) => {
				if (res.status === 201) {} else if (res.status === 400) {}
				return res.json();
			})
			.then((js) => {
				this.form.status = js.data[0].status;
				this.form.category = js.data[0].category;
					const item = js.data[0];

					this.form.id       = item?.data?.id       ?? null;
					this.form.title    = item?.data?.title    ?? null;
					this.form.category = item?.data?.category ?? null;
					this.form.status   = item?.status         ?? 0;
					this.form.response = item?.response       ?? null;
					this.form.message  = item?.message        ?? null;
				let nRow = this.form.nRow;
				var aData = this.form;

				this.table.fnUpdate(aData, nRow);
				this.errorNote = this.table.fnGetData().filter((el) => { return el.status == 0; }).length > 0;
				$("td .btn.edit", nRow).click();

				if (js.data[0].status == 0) {
					$(nRow).css('background-color', '#F7EBEB');
				} else {
					$(nRow).css('background-color', '');
				}

				this.form = {
					refcode: null,
					category: null,
					title: null,
					message: null
				};

				this.errors = {
					refcode: false,
					category: false,
					title: false,
					message: false
				};

				$(this.$refs.modalUpdate).modal("hide");
				this.updating = false;
			});
		},
		submitForm() {
			this.updating = true;
			$('.loading-overlay').addClass('show');

			authFetch("/ticket/claim/closecourierbatch", {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json"
				},
				body: JSON.stringify(this.table.fnGetData())
			})
			.then(res => res.json())
			.then(js => {
				// Matikan loading saat response datang
				$('.loading-overlay').removeClass('show');
				this.updating = false;

				if (js.status === 'success') {
					this.customSwal.fire({
						html: `<img src="${this.getImage('ok')}" class="swal2-img d-block mx-auto mb-3" />
							<div class="h5">${js.message}</div>`,
						showConfirmButton: false,
						showCancelButton: true,
						cancelButtonText: 'Kembali'
					});
					this.$router.push({ path: '/settings/tickets/claimcourier' });

				} else if (js.status === 'error') {
					// Logika menampilkan detail error jika ada resi yang tidak ditemukan
					let errorList = 'Coba beberapa saat lagi';
					
					if (js.errors && js.errors.length > 0) {
						errorList = js.errors.map(err => `<li>${err.refcode}: ${err.message}</li>`).join('');
					} else if (js.details) {
						errorList = Object.keys(js.details).map(key => `<li>${js.details[key]}</li>`).join('');
					}

					this.customSwal.fire({
						html: `<img src="${this.getImage('overload')}" class="swal2-img d-block mx-auto mb-3" />
							<div class="h5">${js.message}</div>
							<div class="w-75 m-auto" style="height: 100px; overflow-y: auto;">
								<ul class="text-left">${errorList}</ul>
							</div>`,
						showConfirmButton: false,
						showCancelButton: true,
						cancelButtonText: 'Kembali'
					});
				} else {
					this.customSwal.fire({
						html: `<img src="${this.getImage('warning')}" class="swal2-img d-block mx-auto mb-3" />
							<div class="h5">Terjadi kesalahan</div>
							<div class="w-75 m-auto">Coba beberapa saat lagi</div>`,
						showConfirmButton: false,
						showCancelButton: true,
						cancelButtonText: 'Kembali'
					});
				}
			})
			.catch(err => {
				$('.loading-overlay').removeClass('show');
				this.updating = false;
				console.error("Error:", err);
			});
		}
	},
	beforeRouteUpdate(to, from, next) {
		this.customSwal.fire({
			html: '<img src="' + require('../assets/img/warning.svg') + '" class="swal2-img d-block mx-auto mb-3" /><div class="h5">Ingin membatalkan proses unggah tiket?</div>',
			showDenyButton: true,
			confirmButtonText: 'Ya, batalkan',
			denyButtonText: 'Kembali'
		}).then((result) => {
			if (result.isConfirmed) {
				next();
			} else {
				next(false);
			}
		});
	},
	components: {
		vSelect
	},
	created() {
        $('.loading-overlay').addClass('show');
	},
	mounted() {
		this.customSwal = Swal.mixin({
			customClass: {
				content: 'p-0',
				title: 'h4 tex-dark',
				input: 'form-control',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary col font-weight-bold',
				denyButton: 'btn btn-outline-primary col font-weight-bold',
				cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
			},
			buttonsStyling: false
		});

		const self = this;

		if (!this.$route.params.claims) {
			this.customSwal.fire({
				html: '<img src="' + self.getImage('overload') + '" class="swal2-img d-block mx-auto mb-3" /><div class="h6">Data AWB tiket kosong</div>',
				showConfirmButton: false,
				showCancelButton: true,
				cancelButtonText: 'Kembali'
			});
			this.$router.push({ path: '/settings/tickets/claimcourier' });
			return;
		}

		if (this.$route.params.claims.length > 200) {
			this.customSwal.fire({
				html: '<img src="' + self.getImage('overload') + '" class="swal2-img d-block mx-auto mb-3" /><div class="h6">Jumlah AWB yang dapat dimuat maksimal 200 tiket</div>',
				showConfirmButton: false,
				showCancelButton: true,
				cancelButtonText: 'Kembali'
			}).then((result) => {
				self.$router.push({ path: '/settings/tickets/claimcourier' });
			});
		}

		/*
		authFetch("/ticket/categories").then((res) => {
			res.json().then((json) => {
				if (json.success) {
					this.categories = json.data;
				}
			});
		});
		*/

		const formData = new URLSearchParams();

		Object.keys(this.$route.params.claims).forEach((key) => {
			const claim = this.$route.params.claims[key];
			formData.append('awb[]', claim.refcode);
			formData.append('action[]', claim.action);
			formData.append('message[]', claim.message);
		});

		authFetch('/ticket/claim/detail', {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded" // Menggunakan Content-Type standard form
			},
			body: formData
		})
		.then((res) => {
			if (res.status === 201) {} else if (res.status === 400) {}
			return res.json();
		})
		.then((js) => {
			self.claim_list = self.$route.params.claims;

			Object.keys(self.claim_list).map((key) => {
				const item = js.data[key];

				self.claim_list[key].id       = item?.data?.id       ?? null;
				self.claim_list[key].title    = item?.data?.title    ?? null;
				self.claim_list[key].category = item?.data?.category ?? null;
				self.claim_list[key].status   = item?.status         ?? 0;
				self.claim_list[key].response = item?.response       ?? null;
				self.claim_list[key].message  = item?.message        ?? null;
			});

			self.table = createTable(self.$refs.claimBatch, {
				data: self.claim_list,
				serverSide: false,
				selectedRowClass: "",
				frame: false,
				scrollX: true,
				displayLength: 10,
				lengthChange: false,
				filter: false,
				order: [],
				columns: [
					{
						data: 'id',
						visible: false,
						sortable: false,
						render: function (data, type, row, meta) {
							return `<input type="checkbox" class="select-request" value="${data}" />`;
						}
					},
					{ data: 'refcode' },
					{ data: 'title' },
					{ data: 'category' },
					{
						data: 'action',
						render: function (data, type, row, meta) {
							return data ? `<span class="badge badge-${['danger', 'warning', 'success', 'danger'][row.response]}">${data}</span>` : '';
						}
					},
					{ data: 'message' },
					{
						data: 'status',
						render: function (data, type, row, meta) {
							return data !== null ? `<span class="badge badge-${['danger', 'success'][data]}">${['Tidak ditemukan', 'Claim tersedia'][data]}</span>` : '';
						}
					},
					{
						data: 'id',
						sortable: false,
						render: function (data, type, row, meta) {
							return `<div class="d-inline-flex align-items-center justify-content-around w-100" style="gap: 7.5px">
								<i class="fi fi-rr-edit text-warning text-lg cursor-pointer" data-action="edit" data-id="${row}"></i>
								<i class="fi fi-rr-trash text-danger text-lg cursor-pointer" data-action="remove" data-id="${row}"></i>
							</div>`;
						},
					},
				],
				"createdRow": function( row, data, dataIndex ) {
					if (data['status'] == 0) {
						$(row).css('background-color', '#F7EBEB');
						self.errorNote = true;
					}
				},
				initComplete: function () {
					$('.loading-overlay').removeClass('show');
				}
			});
		});
	}
}
</script>